<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Tabs :animated="false">
      <TabPane label="基础信息">
        <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
          <FormItem label="公司名称" prop="name">
            <Input v-model="form.name" :maxlength="128"></Input>
          </FormItem>
          <FormItem label="公司类型" prop="enterpriseType">
            <sl-select v-model="form.enterpriseType" type="select" dict="$enterpriseType"></sl-select>
          </FormItem>
          <FormItem label="统一信用代码" prop="unionCreditCode">
            <Input v-model="form.unionCreditCode" :maxlength="64" :disabled="!!this.id"></Input>
          </FormItem>
          <FormItem label="联系人" prop="contact">
            <Input v-model="form.contact" :maxlength="64"></Input>
          </FormItem>
          <FormItem label="联系电话" prop="contactPhone">
            <Input v-model="form.contactPhone" :maxlength="64"></Input>
          </FormItem>
          <FormItem label="注册地址" prop="regAddress">
            <Input v-model="form.regAddress" :maxlength="32"></Input>
          </FormItem>
          <FormItem label="成立时间" prop="establishDatetime">
            <DatePicker type="date" v-model="form.establishDatetime" placement="bottom-start" style="width:100%"></DatePicker>
          </FormItem>
          <FormItem label="公司地址" prop="businessAddress">
            <Input v-model="form.businessAddress" :maxlength="32"></Input>
          </FormItem>
          <FormItem label="法人姓名" prop="legalName">
            <Input v-model="form.legalName" :maxlength="16"></Input>
          </FormItem>
          <FormItem label="法人身份证" prop="legalIdentity">
            <Input v-model="form.legalIdentity" :maxlength="18"></Input>
          </FormItem>
          <FormItem label="法人联系电话" prop="legalPhone">
            <Input v-model="form.legalPhone" :maxlength="32"></Input>
          </FormItem>
          <FormItem label="实控人姓名" prop="controlName">
            <Input v-model="form.controlName" :maxlength="16"></Input>
          </FormItem>
          <FormItem label="实控人身份证" prop="controlIdentity">
            <Input v-model="form.controlIdentity" :maxlength="18"></Input>
          </FormItem>
          <FormItem label="实控人联系电话" prop="controlPhone">
            <Input v-model="form.controlPhone" :maxlength="16"></Input>
          </FormItem>
          <FormItem label="实控人工作年限" prop="controlPhone">
            <InputNumber :min="0" :step="1" v-model="form.workYear"></InputNumber>
          </FormItem>
          <FormItem label="企业邮箱" prop="email">
            <Input v-model="form.email" :maxlength="16"></Input>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="form.remark"></Input>
          </FormItem>
        </Form>
      </TabPane>
      <TabPane label="附件">
        <!-- <ci-enterprise-annex :data="annexes" :id="id"></ci-enterprise-annex> -->
        <sl-annex ref="annex" :related="[1,2,3,4,5,6,7,8,9,10,11,12,13,14]" :data="annexes" :preview-parser="previewParser" :action-parser="actionParser" :on-remove="handleRemove"></sl-annex>
      </TabPane>
      <TabPane label="备胎资料说明">
        <sl-label title="附件">
          <p>网点近6个月收派件量截图照片</p>
          <p>法定代表人或实际控制人身份证正面照片 </p>
          <p>法定代表人或实际控制人身份证反面照片</p>
          <p>经营场地照片</p>
        </sl-label>
        <sl-label title="数据">
          <p>法人代表/负责人姓名,网点属性为分公司和独立法人时必须</p>
          <p>营业执照名称,网点属性为分公司和独立法人时必须</p>
          <p>法人代表/负责人身份证号,网点属性为分公司和独立法人时时必须</p>
        </sl-label>
      </TabPane>
      <TabPane label="满溢资料说明">
        <sl-label title="附件">
          <p>营业执照正本</p>
          <p>实控人身份证反面（人像面） </p>
          <p>开户许可证/一般户引鉴卡</p>
          <p>法人身份证正面（国徽面）</p>
          <p>法人身份证反面（人像面） </p>
          <p>实控人身份证正面（国徽面）</p>
          <p>实控人身份证反面（人像面） </p>
          <p>近6个月收派件量截图 </p>
          <p>天邮与供应商的打款电子回单</p>
          <p>《授权委托书》照片件 </p>
        </sl-label>
        <sl-label title="数据">
          <p>关企业的名称</p>
          <p>企业的联系人号码</p>
          <p>企业的邮箱</p>
          <p>企业的成立时间</p>
          <p>企业的注册地址</p>
          <p>企业的法人身份证号码</p>
          <p>企业的法人手机号</p>
          <p>企业的法人姓名</p>
          <p>企业的实控人身份证号码</p>
          <p>企业的实控人姓名</p>
          <p>企业的实控人手机号</p>
        </sl-label>
      </TabPane>
    </Tabs>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
  import ciEnterpriseAnnex from './annex'
  export default {
    components:{ciEnterpriseAnnex},
    data() {
      const validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入联系电话'));
        } else {
          if(
            /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value) || 
            /^1(3|4|5|7|8)\d{9}$/.test(value)
            ){
            callback()
        }else{
          callback(new Error('请输入正确格式的电话号码'));
        }
      }
    }
    return {
      rules: {
        name: [{ required: true, message: '请输入公司名称', trigger: 'blur,change' }],
        enterpriseType: [{ type:'number', required: true, message: '请选择企业类型', trigger: 'blur,change' }],
      },
      def: {},
      form: {
        id: null,
        unionCreditCode:null,
        enterpriseType:null,
        name: null,
        contact:null,
        contactPhone:null,
        regAddress:null,
        businessAddress:null,
        legalName:null,
        legalIdentity:null,
        legalPhone:null,
        controlName:null,
        controlIdentity:null,
        controlPhone:null,
        workYear:null,
        email:null,
        establishDatetime:null,
        remark: null,
      },
      id:null,
      annexes:[],
      modalVisible:false,
      loading: false,
      isCreate: true,
    }
  },

  created() {
    this.def = { ...this.form }
  },

  computed:{
    itemTitle(){
      return this.id ? '编辑企业信息' : '添加企业信息'
    }, 
    action(){
      return this.$request.ciFileUploadUrl()
    },
  },
  methods: {
    query() {
      // this.$request.goodsCate().then(resp => {
        // this.cates = resp.data
        this.$request.ciEnterprise(this.id).then(resp => {
          this.$utils.fill(this.form, resp.data)
          this.annexes = (resp.data.annexes || []).map( ({id , fileType}) => ({id , fileType , enterpriseId:this.id}))
        })
      // })

    },

    init( id ){
      this.id = id
      this.reset()
      this.modalVisible = true
      if(this.id){
        this.query()
      }
    },

    reset(){
      this.annexes = []
      this.$utils.fill(this.form, this.def)
      this.$refs['form'].resetFields()
    },


    save() {
      //
      let params = { ...this.form }
      this.loading = true

      let exec = this.id ? this.$request.ciEnterpriseUpdate : this.$request.ciEnterpriseCreate

      exec(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')
        }
        this.loading = false
      })

    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleClose() {
      this.$emit('on-update')
    },
    actionParser(data){
      let action = this.$request.ciFileUploadUrl()
      let url = this.action + `?fileType=${data.fileType}&enterpriseId=${this.id}`
      //存在时 替换
      if( data.id ){
        url += '&id=' + data.id
      }
      return url
    },

    previewParser(data){
      if( data.id ){
        console.log('previewParser' ,this.$request.ciFileUrl(data.id) )
        return this.$request.ciFileUrl(data.id)
      }
    },

    handleRemove(data){
      return new Promise((resolve) => {
        this.$ui.confirm(this.$request.ciFileDelete, `确定删除？`)(data.id).then(resp => {
          if (!resp.code) {
            this.$Message.success('操作成功')
            resolve(true)
          }else{
            this.$Message.error(resp.message)
            resolve(false)
          }
        },()=>{
          resolve(false)
        })
      })
    }
  }
}

</script>